export default __webpack_public_path__ + "static/media/formsearch.ca565fc5.jpg";